import React from 'react'
import styled from 'styled-components'
import GD from '../GD'
import { Message } from './Message'

const ChatMessagesDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  max-width: 100%;
  width: 100%;
  height: 100%;
`

const LoadMoreBtn = styled.div`
  background-color: #950a44;
  padding: 6px 20px 6px 20px;
  font-size: 11px;
  color: rgba(255, 255, 255, 1);
  white-space: nowrap;
  border-radius: 10px;
  margin: 0 0 10px 0;
  text-align: center;
  width: auto;
  align-self: center;
  position: sticky;
  z-index: 2;
  cursor: pointer;
`

const MessageList = () => {
  const [messages, setMessages] = React.useState<IMessage[]>([])

  const hasMoreMessages = React.useRef(false)

  React.useEffect(() => {
    GD.SET_MESSAGES.subscribe(messages => {
      hasMoreMessages.current = messages?.[0]?.num > 1
      setMessages([...messages])
    }, 'MessageList')

    return () => {
      GD.SET_MESSAGES.unsubscribe('MessageList')
    }
  }, [])

  React.useEffect(() => {
    GD.GUI_MESSAGES_RENDERED.invoke()
  }, [messages])

  return (
    <>
      <ChatMessagesDiv>
        {hasMoreMessages.current && (
          <LoadMoreBtn onClick={() => GD.FETCH_MORE_MESSAGES.request()}>LOAD MORE MESSAGES</LoadMoreBtn>
        )}
        {messages?.length ? messages.map((el, idx) => (
          <Message
            key={el.id || Math.random().toString(36).substring(7)}
            message={el}
            isLast={idx === messages.length - 1}
          />
        )) : null}
      </ChatMessagesDiv>
    </>
  )
}

export default MessageList
